<nav class="navbar navbar-expand-md navbar-light">
    <a class="title_taskmanager" routerLink="">Alarms</a>
    <!-- <a class="home" class="navbar-brand" [routerLink]="['/board']" routerLinkActive="active"
        #board="routerLinkActive"><img src="../../../assets/images/Group 112174.svg"></a> -->

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
</nav>